export { default } from "./ClimberSplashRoot";
